import React from "react";
import { TableCell, Typography } from "@material-ui/core";
import { AudioControlButton } from "frontend/src/ui/audio-control-button";
import { TrackRow } from "frontend/src/ui/track-row";
import { useTimetableRelationToPlayer } from "frontend/src/features/show-entities-relations-to-player";
import { pause } from "frontend/src/features/control-audio";
import { playTodayTimetableAttempted } from "frontend/src/features/play-todays-timetable";
export var MobileTimetableRow = function (_a) {
    var id = _a.id, title = _a.title;
    var _b = useTimetableRelationToPlayer(id), isPlaying = _b.isPlaying, isLoading = _b.isLoading, isSelectedForPlayer = _b.isSelectedForPlayer;
    var play = function () { return playTodayTimetableAttempted({ id: id, title: title }); };
    return (React.createElement(TrackRow, { isSelectedForPlayer: isSelectedForPlayer },
        React.createElement(TableCell, null,
            React.createElement(AudioControlButton, { isLoading: isLoading, onPause: pause, onPlay: play, isPlaying: isPlaying })),
        React.createElement(TableCell, null,
            React.createElement(Typography, null, title))));
};
export var DesktopTimetableRow = function (_a) {
    var id = _a.id, title = _a.title;
    var _b = useTimetableRelationToPlayer(id), isPlaying = _b.isPlaying, isLoading = _b.isLoading, isSelectedForPlayer = _b.isSelectedForPlayer;
    var play = function () { return playTodayTimetableAttempted({ id: id, title: title }); };
    return (React.createElement(TrackRow, { isSelectedForPlayer: isSelectedForPlayer },
        React.createElement(TableCell, { width: "5%" },
            React.createElement(AudioControlButton, { isLoading: isLoading, onPause: pause, onPlay: play, isPlaying: isPlaying })),
        React.createElement(TableCell, null, title)));
};
